import type {CohortFormSelectTriggerStruct} from '@cohort/shared/apps/cohort-form/triggers/select';
import {CohortFormSelectTriggerIntegrationSpec} from '@cohort/shared/apps/cohort-form/triggers/select';
import CohortFormSelectUsageComponent from '@cohort/wallet/apps/cohort-form/triggerIntegrations/select/UsageComponent';
import type {TriggerIntegration} from '@cohort/wallet/apps/TriggerIntegration';

export const CohortFormSelectTriggerIntegration: TriggerIntegration<CohortFormSelectTriggerStruct> =
  {
    type: 'embedded',
    spec: CohortFormSelectTriggerIntegrationSpec,
    usageComponent: CohortFormSelectUsageComponent,
    disableExponentialBackoff: true,
  };
